import React from "react";

const LeadCardSkeleton = () => {
  return (
    <div className="bg-white rounded-lg font-poppins shadow-sm border-2 border-gray-200 animate-pulse">
      <div className="flex flex-col lg:flex-row gap-4">
        {/* Left profile section */}
        <div className="flex-shrink-0 flex flex-col items-center p-4 sm:p-3">
          {/* Profile circle */}
          <div className="w-20 h-20 sm:w-16 sm:h-16 lg:w-20 lg:h-20 rounded-full bg-gray-200"></div>

          {/* Action buttons */}
          <div className="flex sm:flex-col gap-2 mt-4">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="p-2.5 size-11 rounded-full bg-gray-200"
              ></div>
            ))}
          </div>
        </div>

        {/* Right details section */}
        <div className="flex-1 flex-col divide-y divide-gray-200">
          {/* Top: User details & status */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            <div className="lg:border-r py-4 px-4 lg:px-0 border-primary-navy/10">
              <div className="h-4 bg-gray-200 w-3/4 rounded mb-2"></div>
              <div className="h-3 bg-gray-200 w-1/2 rounded"></div>
            </div>

            {/* Phone, Email, Location */}
            <div className="space-y-3 py-4 px-4 lg:px-0 text-sm">
              {[1, 2, 3].map((i) => (
                <div key={i} className="h-3 bg-gray-200 w-3/4 rounded"></div>
              ))}
            </div>

            {/* Status dropdown */}
            <div className="flex w-full h-full items-end justify-start lg:justify-end p-4">
              <div className="w-full lg:w-auto h-10 bg-gray-200 rounded-lg"></div>
            </div>
          </div>

          {/* Search criteria */}
          <div className="text-sm grid grid-cols-1 sm:grid-cols-2 md:grid-cols-8 gap-4 sm:gap-2 py-4 px-4 lg:px-0">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className={`col-span-1 md:col-span-${
                  i === 1 ? "2" : "3"
                } flex gap-x-4`}
              >
                <div className="h-full border-[3px] rounded-full border-gray-300/50 hidden sm:block"></div>
                <div className="space-y-2 w-full">
                  <div className="h-3 bg-gray-200 w-1/2 rounded"></div>
                  <div className="h-4 bg-gray-200 w-3/4 rounded"></div>
                </div>
              </div>
            ))}
          </div>

          {/* Property details */}
          <div className="flex justify-between flex-col gap-2 items-center sm:flex-row p-4 lg:px-0">
            <div className="flex gap-3">
              <div className="w-20 h-[4.5rem] sm:w-24 sm:h-[4.5rem] bg-gray-200 rounded-md"></div>
              <div className="p-2">
                <div className="h-4 bg-gray-200 w-24 rounded mb-2"></div>
                <div className="h-3 bg-gray-200 w-16 rounded"></div>
              </div>
            </div>
            <div className="self-end">
              <div className="h-3 bg-gray-200 w-20 rounded"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadCardSkeleton;
